import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import * as St from './MaterialsList.styles';

import { TooltipArrowStyle } from '~atoms/DescriptionAndRating';
import PageSubtitle from '~atoms/PageSubtitle';
import type { MaterialCardData } from '~molecules/MaterialCard';
import MaterialCard from '~molecules/MaterialCard';

export type MaterialsListData = {
  materials: MaterialCardData[];
};

type MaterialsListProps = {
  data: MaterialsListData;
  selectedMaterialId?: string;
  onSelectMaterial: (materialId: string) => void;
};

const MaterialsList = ({
  data,
  selectedMaterialId,
  onSelectMaterial,
}: MaterialsListProps) => {
  const subtitleId = useId();
  const { t } = useTranslation();

  return (
    <>
      <PageSubtitle id={subtitleId}>
        {t('SCROLLABLE_AREA.MATERIAL.DESCRIPTION')}
      </PageSubtitle>
      <TooltipArrowStyle />
      <St.Container role="list" aria-labelledby={subtitleId}>
        {data.materials.map((material) => (
          <MaterialCard
            role="listitem"
            key={material.id}
            isSelected={selectedMaterialId === material.id}
            data={material}
            onSelect={() => onSelectMaterial(material.id)}
          />
        ))}
      </St.Container>
    </>
  );
};

export default MaterialsList;
